import request from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { newGatewayUrl } from '@/constant';
import {
  AbTestResult, AbTestQuery, UserCertEnum, HelloCertEnum,
} from './types';

export const getIfIsTestUser = (): Promise<boolean> => request.postGate(
  'f.loan.gw.isTest',
  {},
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

/**
 * 用于区分用户是否命中aTtest
 * * */
export const getAbTestUser = (params:AbTestQuery): Promise<AbTestResult> => request.postGate(
  'f.common.abTest.divide',
  params,
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

/**
 * f.user.registLogin.info(臻有钱用户外投注册登录信息落库接口)
 * https://yapi.hellobike.cn/project/3415/interface/api/269229
 * * */
export const postLoginInfo = (
  source: string,
  /** 支持优酷撞库，传入友盟orderId */
  thirdOrderId?: string,
): Promise<boolean> => requestDefault
  .postGate(
    'f.user.registLogin.info',
    {
      source,
      thirdOrderId,
    },
  );

/**
 * f.user.bio.pre.queryUserIdentity(实名信息前置校验查询)
 * https://yapi.hellobike.cn/project/7006/interface/api/317243
 * * */
export const getPlatformUserStatus = (
): Promise<{
  /** 用户实名方式 */
  userCertMode: UserCertEnum,
  /** 平台实名类型 */
  helloCertType: HelloCertEnum,
  /** 是否需要重新上传身份证图片, 0 否， 1 是 */
  needReUpload: number
}> => requestDefault
  .postGate(
    'f.user.bio.pre.queryUserIdentity',
  );
